import { useDebugStore, type DebugCategory, type DebugLogLevel } from './debug-store';

export function debugLog(
  category: DebugCategory,
  level: DebugLogLevel,
  message: string,
  entityId?: string,
): void {
  useDebugStore.getState().push({ category, level, message, entityId });
}
